import React, { useContext, useEffect, useState } from 'react';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { Button, TextField, Grid } from '@material-ui/core';
import LanguageChangeCard from '../../molecules/Card/LanguageChangeCardEx';
import { AppContext } from '../../../App';
import { useTranslation } from 'react-i18next';
import OKCancelDialog from '../../atoms/Dialog/OKCancelDialog';
import MessageDialog, { MessageDialogResponse } from '../../atoms/Dialog/MessageDialog';
import bgImage from '../../../image/loginBack.png';
import bgImageE from '../../../image/loginBackE.png';
import { ErrorCode } from '../../../ErrorCode';

import LoginUserSettingPassWordChangeBody from '../CustomConfig/LoginUserSetting/LoginUserSettingPassWordChangeBody';
import { passwordCheckType } from '../CustomConfig/LoginUserSetting/LoginUserSetting';

import { TableBaseStyle } from './LoginStyle';
import LoginMode from './LoginMode';
import SendLoginMode from './SendLoginMode';
import LoginTwoPasswordMode from './LoginTwoPasswordMode';
import { useModal } from '../../../function/useModal';
import { USER_MNG, GetUserInfos, UpdatePassword, CheckPasswordFormat } from '../../../function/UserManageModel';
import { VersionInfoModel, GetVersionInfo } from '../../../function/VersionInfoModel';
import LoginMailAdress from './LoginMailAdress';

type LoginPageProps = {
  userid: string;
};

const LoginPage: React.FC<LoginPageProps> = (props) => {
  const classes = TableBaseStyle();
  const { login, state } = useContext(AppContext);
  const [user, setUser] = useState<string>(props.userid);
  const [password, setPassword] = useState<string>('');
  const [oneteimePassword, setOneteimePassword] = useState<string>('');
  const [mailAdress, setMailAdress] = useState<string>('');
  const { t } = useTranslation();
  const [flgMsgDlg, actMsgDlg] = useModal<MessageDialogResponse>();
  const [dlgtitle, setDlgtitle] = useState<string>('');
  const [dlgmsg, setDlgmsg] = useState<string>('');
  const [containerStyle, setContainerStyle] = useState<string>(classes.loginContainer);
  const [dialogOpen, setDialogOpen] = React.useState(false);
  const [loginMode, setLoginMode] = useState<boolean>(false);
  const [onetimePassMode, setOnetimePassMode] = useState<boolean>(false);
  const [entryMailAdressMode, setEntryMailAdressMode] = useState<boolean>(false);
  const [onetimePasswordValidityTime, setOnetimePasswordValidityTime] = useState<number>(0);
  const [versionInfo, setVersionInfo] = useState<string>('');

  const cfmdlg = flgMsgDlg ? <MessageDialog dialog={actMsgDlg} title={dlgtitle} message={dlgmsg} /> : null;

  const [passCheck, setPassCheck] = React.useState<passwordCheckType>({
    indexNo: 0,
    nowPassword: '',
    newPassword: '',
    confirmationPassword: '',
    hasPassword: true,
  });

  /**
   * ログイン画面のパターン確認
   * true:2段階認証モード
   */
  useEffect(() => {
    /* バージョン情報を取得*/
    GetVersionInfo().then((result) => {
      console.log('varsion info', result);
      const response = result.responceData;

      if (response.ErrorCode !== ErrorCode.ERR_CODE_NONE) {
        console.error('Failed to get version information');
        setVersionInfo('');
      }
      else {
        setVersionInfo(result.Version);
        console.log('varsion info', result);
      }
    });
    /*パターン情報を取得*/
    login.loginMode().then((result) => {
      console.log('loginMode ', result);

      setLoginMode(result);
    });


  }, []);

  useEffect(() => {
    switch (state.lang) {
      case 'en':
        setContainerStyle(classes.loginContainerE);
        break;
      case 'ja':
      default:
        setContainerStyle(classes.loginContainer);
        break;
    }
  }, [state.lang]);

  /**
   * ログイン処理
   * @returns
   */
  const loginAction = () => {
    if (user === '') {
      setDlgtitle(t('Login.ログインエラー', 'ログインエラー'));
      setDlgmsg(t('Login.ユーザIDを入力してください', 'ユーザIDを入力してください'));
      actMsgDlg.open();
      return;
    }
    if (password === '') {
      setDlgtitle(t('Login.ログインエラー', 'ログインエラー'));
      setDlgmsg(t('Login.パスワードを入力してください', 'パスワードを入力してください'));
      actMsgDlg.open();
      return;
    }

    let errorMsg = CheckPasswordFormat(password, t);
    if (user !== 'root' && errorMsg !== '') {
      setDlgtitle(t('Login.ログインエラー', 'ログインエラー'));
      setDlgmsg(errorMsg);
      actMsgDlg.open();
      return;
    }

    console.debug('User:', user);
    login.login(user, password).then((result) => {
      console.log('Login ', result);
      if (result.ResponceData.ErrorCode !== 0) {
        if (result.ResponceData.ErrorCode === ErrorCode.ERR_CODE_USER_PASSWORD_NOMATCH) {
          setDlgtitle(t('Login.ログインエラー', 'ログインエラー'));
          setDlgmsg(t('Login.エラー', 'ユーザーまたはパスワードが違います'));
          actMsgDlg.open().apply((resp) => {
            setUser('');
            setPassword('');
          });
        } else if (result.ResponceData.ErrorCode === ErrorCode.ERR_CODE_USER_NO_USER) {
          setDlgtitle(t('Login.ログインエラー', 'ログインエラー'));
          setDlgmsg(t('Login.ユーザーIDが存在しません', 'ユーザーIDが存在しません'));
          actMsgDlg.open().apply((resp) => {
            setUser('');
            setPassword('');
          });
        } else if (result.ResponceData.ErrorCode === ErrorCode.ERR_CODE_USER_LOCK) {
          setDlgtitle(t('Login.ログインエラー', 'ログインエラー'));
          setDlgmsg(
            t(
              'Login.ログイン制限がかかっているため_ログインできません',
              'ログイン制限がかかっているため、ログインできません'
            )
          );
          actMsgDlg.open().apply((resp) => {
            setUser('');
            setPassword('');
          });
        } else if (result.ResponceData.ErrorCode === ErrorCode.ERR_CODE_USER_PASSWORD_EXPIRATION) {
          setDlgtitle(t('Login.ログインエラー', 'ログインエラー'));
          setDlgmsg(
            t('Login.パスワード有効期限切れ', 'パスワードの有効期限が切れています、パスワードの変更をしてください')
          );
          actMsgDlg.open().apply((resp) => {
            setDialogOpen(true);
          });
        } else if (result.ResponceData.ErrorCode === ErrorCode.ERR_CODE_USER_LOGIN) {
          setDlgtitle(t('Login.ログインエラー', 'ログインエラー'));
          setDlgmsg(
            t('Login.ユーザー名', 'ユーザー名') +
            result.ResponceData.ErrorMessage +
            t('Login.が既にログインしています', 'が既にログインしています')
          );
          actMsgDlg.open().apply((resp) => {
            setUser('');
            setPassword('');
          });
        } else {
          setDlgtitle(t('Login.ログインエラー', 'ログインエラー'));
          setDlgmsg(t('Login.システムエラーが発生しました', 'システムエラーが発生しました'));
          actMsgDlg.open().apply((resp) => {
            setUser('');
            setPassword('');
          });
        }
      }
    });
  };

  /**
   * ワンタイムパスワード送信処理
   */
  const SendMailAction = () => {
    if (user === '') {
      setDlgtitle(t('Login.2段階認証パスワード送信エラー', '2段階認証パスワード送信エラー'));
      setDlgmsg(t('Login.ユーザIDを入力してください', 'ユーザIDを入力してください'));
      actMsgDlg.open();
      setOnetimePassMode(false);
      return;
    }
    if (password === '') {
      setDlgtitle(t('Login.2段階認証パスワード送信エラー', '2段階認証パスワード送信エラー'));
      setDlgmsg(t('Login.パスワードを入力してください', 'パスワードを入力してください'));
      actMsgDlg.open();
      setOnetimePassMode(false);
      return;
    }
    let errorMsg = CheckPasswordFormat(password, t);
    if (user !== 'root' && errorMsg !== '') {
      setDlgtitle(t('Login.2段階認証パスワード送信エラー', '2段階認証パスワード送信エラー'));
      setDlgmsg(errorMsg);
      actMsgDlg.open();
      setOnetimePassMode(false);
      return;
    }
    console.debug('SendMailAction User:', user);

    //2段階認証パスワード送信処理
    login.sendPassword(user, password).then((result) => {
      console.log('SendMailAction result', result);
      if (result.ResponceData.ErrorCode === ErrorCode.ERR_CODE_NONE) {
        console.log('パスワード送信完了');
        //特殊ユーザー権限処理
        if (result.AdminUserId == true) {
          loginAction();
        } else {
          setOnetimePasswordValidityTime(result.OnetimePasswordValidityTime);
          setOnetimePassMode(true);
          //メールアドレス登録モードを閉じる
          setEntryMailAdressMode(false);
        }
      } else if (result.ResponceData.ErrorCode === ErrorCode.ERR_CODE_USER_PASSWORD_NOMATCH) {
        setDlgtitle(t('Login.2段階認証パスワード送信エラー', '2段階認証パスワード送信エラー'));
        setDlgmsg(t('Login.パスワードが違います', 'パスワードが違います'));
        actMsgDlg.open().apply((resp) => {
          setPassword('');
          setOnetimePassMode(false);
        });
      } else if (result.ResponceData.ErrorCode === ErrorCode.ERR_CODE_USER_NO_USER) {
        setDlgtitle(t('Login.2段階認証パスワード送信エラー', '2段階認証パスワード送信エラー'));
        setDlgmsg(t('Login.ユーザーIDが存在しません', 'ユーザーIDが存在しません'));
        actMsgDlg.open().apply((resp) => {
          setUser('');
          setPassword('');
          setOnetimePassMode(false);
        });
      } else if (result.ResponceData.ErrorCode === ErrorCode.ERR_CODE_USER_PASSWORD_EXPIRATION) {
        setDlgtitle(t('Login.2段階認証パスワード送信エラー', '2段階認証パスワード送信エラー'));
        setDlgmsg(
          t('Login.パスワード有効期限切れ', 'パスワードの有効期限が切れています、パスワードの変更をしてください')
        );
        actMsgDlg.open().apply((resp) => {
          setDialogOpen(true);
          setOnetimePassMode(false);
        });
      } else if (result.ResponceData.ErrorCode === ErrorCode.ERR_CODE_USER_LOCK) {
        setDlgtitle(t('Login.2段階認証パスワード送信エラー', '2段階認証パスワード送信エラー'));
        setDlgmsg(
          t(
            'Login.ログイン制限がかかっているため_ログインできません',
            'ログイン制限がかかっているため、ログインできません'
          )
        );
        actMsgDlg.open().apply((resp) => {
          setUser('');
          setPassword('');
          setOnetimePassMode(false);
        });
      } else if (result.ResponceData.ErrorCode === ErrorCode.ERR_CODE_USER_NOMAILADRESS) {
        //メールアドレス登録画面に移動
        setEntryMailAdressMode(true);
      } else {
        setDlgtitle(t('Login.2段階認証パスワード送信エラー', '2段階認証パスワード送信エラー'));
        setDlgmsg(t('Login.システムエラーが発生しました', 'システムエラーが発生しました'));
        actMsgDlg.open().apply((resp) => {
          setUser('');
          setPassword('');
          setOnetimePassMode(false);
        });
      }
    });
  };

  /**
   * 2段階認証 ログイン処理
   * @returns
   */
  const ontimeLoginAction = () => {
    if (password === '') {
      setDlgtitle(t('Login.ログインエラー', 'ログインエラー'));
      setDlgmsg(t('Login.パスワードを入力してください', 'パスワードを入力してください'));
      actMsgDlg.open();
      return;
    }

    login.onetimeLogin(user, oneteimePassword).then((result) => {
      console.log('Login ', result);
      if (result.ResponceData.ErrorCode !== 0) {
        if (result.ResponceData.ErrorCode === ErrorCode.ERR_CODE_USER_PASSWORD_NOMATCH) {
          setDlgtitle(t('Login.ログインエラー', 'ログインエラー'));
          setDlgmsg(t('Login.パスワードが違います', 'パスワードが違います'));
          actMsgDlg.open().apply((resp) => {
            setOneteimePassword('');
          });
        } else if (result.ResponceData.ErrorCode === ErrorCode.ERR_CODE_USER_LOCK) {
          setDlgtitle(t('Login.ログインエラー', 'ログインエラー'));
          setDlgmsg(
            t(
              'Login.ログイン制限がかかっているため_ログインできません',
              'ログイン制限がかかっているため、ログインできません'
            )
          );
          actMsgDlg.open().apply((resp) => {
            setOneteimePassword('');
          });
        } else if (result.ResponceData.ErrorCode === ErrorCode.ERR_CODE_USER_PASSWORD_EXPIRATION) {
          setDlgtitle(t('Login.ログインエラー', 'ログインエラー'));
          setDlgmsg(
            t(
              'Login.ワンタイムパスワードの有効期限が切れています再度パスワードを発行してください',
              'ワンタイムパスワードの有効期限が切れています、再度パスワードを発行してください'
            )
          );
          actMsgDlg.open().apply((resp) => {
            backAction();
          });
        } else if (result.ResponceData.ErrorCode === ErrorCode.ERR_CODE_USER_LOGIN) {
          setDlgtitle(t('Login.ログインエラー', 'ログインエラー'));
          setDlgmsg(
            t('Login.ユーザー名', 'ユーザー名') +
            result.ResponceData.ErrorMessage +
            t('Login.が既にログインしています', 'が既にログインしています')
          );
          actMsgDlg.open().apply((resp) => {
            backAction();
            setUser('');
            setPassword('');
          });
        } else {
          setDlgtitle(t('Login.ログインエラー', 'ログインエラー'));
          setDlgmsg(t('Login.システムエラーが発生しました', 'システムエラーが発生しました'));
          actMsgDlg.open().apply((resp) => {
            setUser('');
            setPassword('');
          });
        }
      }
    });
  };

  /**
   * 2段階認証戻るボタン処理
   */
  const backAction = () => {
    //初期化処理
    //setUser('');
    setPassword('');
    setOneteimePassword('');

    setOnetimePassMode(false);
    console.debug('backAction onetimePassMode', onetimePassMode);
  };

  /**
   * メールアドレス登録処理
   * @returns
   */
  const entryMailAdressAction = () => {
    if (mailAdress === '') {
      setDlgtitle(t('Login.メールアドレス登録エラー', 'メールアドレス登録エラー'));
      setDlgmsg(t('Login.メールアドレスを記入してください', 'メールアドレスを記入してください'));
      actMsgDlg.open();
      return;
    }

    login.entryAdress(user, mailAdress).then((result) => {
      console.log('Entry', result);
      //エラー処理確認
      if (result.ResponceData.ErrorCode !== 0) {
        if (result.ResponceData.ErrorCode === ErrorCode.ERR_CODE_USER_NO_USER) {
          setDlgtitle(t('Login.メールアドレス登録エラー', 'Login.メールアドレス登録エラー'));
          setDlgmsg(t('Login.ユーザーが存在しません', 'ユーザーが存在しません'));
          actMsgDlg.open().apply((resp) => {
            //1番最初の画面に戻る
            setEntryMailAdressMode(false);
            backAction();
          });
        } else if (result.ResponceData.ErrorCode === ErrorCode.ERR_CODE_USER_MAILADRESS) {
          setDlgtitle(t('Login.メールアドレス登録エラー', 'Login.メールアドレス登録エラー'));
          setDlgmsg(t('Login.メールアドレスの形式が違います', 'メールアドレスの形式が違います'));
          actMsgDlg.open().apply((resp) => {
            setMailAdress('');
          });
        } else {
          setDlgtitle(t('Login.メールアドレス登録エラー', 'メールアドレス登録エラー'));
          setDlgmsg(t('Login.システムエラーが発生しました', 'システムエラーが発生しました'));
          actMsgDlg.open().apply((resp) => {
            setMailAdress('');
          });
        }
      }
      setMailAdress(result.MAIL_ADRESS);
      //メール送信処理
      SendMailAction();
    });
  };

  /**
   *パスワード変更処理
   */
  const handlePasswordCheckOkButton = () => {
    setDlgtitle(t('Login.パスワード変更エラ', 'パスワード変更エラー'));
    let errorMsg = CheckPasswordFormat(passCheck.newPassword, t);
    if (errorMsg !== '') {
      setDlgmsg(errorMsg);
      actMsgDlg.open();
      return;
    }

    if (passCheck.newPassword !== passCheck.confirmationPassword) {
      setDlgmsg(
        t('LoginUserSettingPage.新しいパスワードと確認用が一致しません', '新しいパスワードと確認用が一致しません')
      );
      actMsgDlg.open();
      return;
    }

    // 現在のパスワードがあるときのみ
    UpdatePassword(user, passCheck.nowPassword, passCheck.newPassword).then((r) => {
      //パスワード変更を反映
      if (r.ErrorCode == 0) {
        setDlgtitle(t('Login.パスワード変更', 'パスワード変更'));
        setDlgmsg(t('LoginUserSettingPage.パスワードが変更されました', 'パスワードが変更されました'));
        actMsgDlg.open().apply((resp) => {
          setPassword('');
          setDialogOpen(false);
        });
      } else if (r.ErrorCode == ErrorCode.ERR_CODE_USER_NO_USER) {
        setDlgmsg(t('LoginUserSettingPage.選択したユーザID情報が不正です', '選択したユーザID情報が不正です'));
        actMsgDlg.open();
      } else if (r.ErrorCode == ErrorCode.ERR_CODE_USER_PASSWORD_NOMATCH) {
        setDlgmsg(t('LoginUserSettingPage.現在のパスワードが違います', '現在のパスワードが違います'));
        actMsgDlg.open();
      } else if (r.ErrorCode == ErrorCode.ERR_CODE_USER_PASSWORD_OLD) {
        setDlgmsg(
          t('LoginUserSettingPage.過去に使用したパスワードは使用できません', '過去に使用したパスワードは使用できません')
        );
        actMsgDlg.open();
      } else if (r.ErrorCode == ErrorCode.ERR_CODE_SYSTEM_ERROR) {
        setDlgmsg(t('LoginUserSettingPage.システムエラーが発生しました', 'システムエラーが発生しました'));
        actMsgDlg.open();
      }
    });
  };

  /**
   * ダイアログで変更した値を管理
   * @param key
   * @param value
   */
  const updatecheckPassword = (key: string, value: string): void => {
    var _passwordCheck = { ...passCheck };
    _passwordCheck = { ..._passwordCheck, [key]: value };
    setPassCheck(_passwordCheck);
  };
  /**
   * ユーザー名変更
   * @param userName
   */
  const changeUserName = (userName: string): void => {
    setUser(userName);
  };
  /**
   * パスワード変更
   * @param userPssword
   */
  const changePassWord = (userPssword: string): void => {
    setPassword(userPssword);
  };

  /**
   * 2段階認証パスワード変更
   * @param twoPassword
   */
  const changeOnetimePassword = (twoPassword: string): void => {
    setOneteimePassword(twoPassword);
  };
  /**
   * メールアドレス登録
   * @param entrymailAdress
   */
  const entryMailAdressName = (entrymailAdress: string): void => {
    setMailAdress(entrymailAdress);
  };

  return (
    <>
      <div className={containerStyle}>
        <Grid container spacing={1}>
          <Grid item xs={10}></Grid>
          <Grid item xs={2}>
            <LanguageChangeCard />
          </Grid>
        </Grid>

        {/**2段階認証ログイン画面に切替　true:2段階認証ログイン画面,false:2段階認証送信処理画面or通常ログイン処理画面*/}
        {onetimePassMode === false ? (
          <>
            {entryMailAdressMode === false ? (
              <>
                <div style={{ height: '58%' }}></div>
                {/**ログインモードの切替処理　true:2段階認証送信処理,false:通常ログイン処理 */}
                {loginMode === false ? (
                  <LoginMode
                    user={user}
                    password={password}
                    version={versionInfo}
                    changeUserName={changeUserName}
                    changePassword={changePassWord}
                    startLoginAction={loginAction}
                  ></LoginMode>
                ) : (
                  <SendLoginMode
                    user={user}
                    password={password}
                    version={versionInfo}
                    changeUserName={changeUserName}
                    changePassword={changePassWord}
                    startSendMailAction={SendMailAction}
                  ></SendLoginMode>
                )}
              </>
            ) : (
              <>
                <div style={{ height: '56%' }}></div>
                <LoginMailAdress
                  mailAdress={mailAdress}
                  EntryMailAdress={entryMailAdressName}
                  entrymailAdressAction={entryMailAdressAction}
                ></LoginMailAdress>
              </>
            )}
          </>
        ) : (
          <>
            <div style={{ height: '56%' }}></div>
            <LoginTwoPasswordMode
              oneteimePassword={oneteimePassword}
              onetimePasswordValidityTime={onetimePasswordValidityTime}
              version={versionInfo}
              changeoneteimePassword={changeOnetimePassword}
              ontimeLoginAction={ontimeLoginAction}
              backAction={backAction}
            ></LoginTwoPasswordMode>
          </>
        )}

        {cfmdlg}
        <OKCancelDialog
          open={dialogOpen}
          onOK={() => handlePasswordCheckOkButton()}
          onCancel={() => setDialogOpen(false)}
          title={t('LoginUserSettingGrid.パスワード変更', 'パスワード変更')}
          okText={t('LoginUserSettingGrid.OK', 'OK')}
          cancelText={t('LoginUserSettingGrid.キャンセル', 'キャンセル')}
          maxWidth={'sm'}
        >
          <LoginUserSettingPassWordChangeBody updatePassword={updatecheckPassword} hasCurrentPass={true} />
        </OKCancelDialog>
      </div>
    </>
  );
};

export default LoginPage;
